document.addEventListener('DOMContentLoaded', () => {
  const createCustomerForm = document.getElementById('create_customer');

  if (createCustomerForm) {
    const formInputs = createCustomerForm.querySelectorAll('input:not([type="hidden"])');
    const formRedirectURL = createCustomerForm.dataset.redirectUrl || `${routes.customer_account}`;

    const createCustomer = async (event) => {
      event.preventDefault();
      const body = new FormData(createCustomerForm);
  
      try {
        const response = await fetch(`${routes.customer_account}`, {
          method: 'POST',
          body: body,
        });

        const responseText = await response.text();
        const parser = new DOMParser();
        const html = parser.parseFromString(responseText, "text/html");
        const inputErrors = html.querySelectorAll('.input__error');
        const formError = html.querySelector('#MainCustomerCreateFormErorr');
  
        if (inputErrors.length > 0 || formError) {
          renderErrors(inputErrors, formError);
        } else {
         await yotpoOptIn(body.get('customer[email]'));
        }
      } catch (error) {
        console.error('Error handling form submission:', error);
      }
    };

    const renderErrors = (inputErrors, formError) => {
      const oldFormError = createCustomerForm.querySelector('#MainCustomerCreateFormErorr');
      const oldInputErrors = createCustomerForm.querySelectorAll('.input__error');

      // remove old errors if exist
      if (oldFormError) oldFormError.remove();
      if (oldInputErrors.length > 0) oldInputErrors.forEach(el => el.remove());

      // render new errors
      if (formError){
        createCustomerForm.insertAdjacentElement('afterbegin', formError);
      }

      if (inputErrors.length > 0){
        formInputs.forEach(input => {
          inputErrors.forEach(err => {
            if (err.dataset.id == input.id){
              // Remove form note if exist
              if (input.parentElement.parentElement.querySelector('.input__note')) input.parentElement.parentElement.querySelector('.input__note').remove();
              input.parentElement.insertAdjacentElement('afterEnd', err);
            }
          });
        });
      }

    };

    const yotpoOptIn = async (email) => {
      const body = {
        email: email,
        opted_in: true,
      };

      await fetch('https://newapp-uyecfyqava-uc.a.run.app/yotpo/createupdate-customer', {
        ...fetchConfig(),
        body: JSON.stringify(body),
      })
        .then((data) => data.json())
        .then((response) => {
          console_log(response);
        })
        .catch((err) => {
          console_log(err);
        })
        .finally(() => {
          window.location.href = formRedirectURL;
        });
    };

    createCustomerForm.addEventListener('submit', (event) => createCustomer(event));
  }
});
